"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.splitInputByLinesAndApplyCallBack = splitInputByLinesAndApplyCallBack;
function splitInputByLinesAndApplyCallBack(input, callback) {
  var inputSplittedByLines = input.split("\n");
  inputSplittedByLines = inputSplittedByLines.map(function (inputLine) {
    return callback(inputLine);
  });
  return inputSplittedByLines.join("\n");
}